import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { environment } from "./util/baseUrl";

const DetalleHistoria = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const historiasBaseUrl = environment.baseUrl + "historias/"; 
    const baseImagenUrl = environment.baseUrl + 'imagenes/'; 

    const [historia, setHistoria] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const formatDate = (dateString) => {
        if (!dateString) return 'Fecha desconocida';
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', options);
    };

    useEffect(() => {
        document.documentElement.style.fontSize = 14 + 'px';
        
        if (id) {
            setLoading(true);
            axios.get(historiasBaseUrl + id) 
                .then(response => {
                    setHistoria(response.data);
                    setLoading(false);
                })
                .catch(err => {
                    console.error("Error al obtener el detalle de la historia:", err);
                    setError("No se pudo cargar la historia. Intente de nuevo más tarde.");
                    setLoading(false);
                });
        }
    }, [id]);

    if (loading) {
        return <div className="text-center mt-5">Cargando historia...</div>;
    }

    if (error) {
        return <div className="text-center mt-5 text-red-500">{error}</div>;
    }

    if (!historia) {
        return <div className="text-center mt-5">Historia no encontrada.</div>;
    }

    return (
        <div className="flex justify-content-center p-4">
            <div className="col-12 md:col-10 lg:col-8">
                
                <h1 className="text-center text-4xl sm:text-5xl md:text-6xl font-bold line-height-2 mt-0 mb-4 text-900">
                    {historia.titulo}
                </h1>
                
                <div className="flex flex-wrap justify-content-center align-items-center text-center text-600 mb-5">
                    
                    <div className="flex align-items-center mx-3 my-1">
                        <i className="pi pi-calendar mr-2"></i> 
                        <span className="font-semibold">{formatDate(historia.fechaPublicacion)}</span>
                    </div>

                    <div className="flex align-items-center mx-3 my-1">
                        <i className="pi pi-user mr-2"></i> 
                        <span className="font-semibold text-color-secondary">{historia.autor || 'Redacción'}</span>
                    </div>

                    <div className="flex align-items-center mx-3 my-1">
                        <i className="pi pi-tag mr-2"></i> 
                        <span className="font-semibold text-blue-700">{historia.categoria ? historia.categoria.titulo : 'General'}</span>
                    </div>
                </div>

                <div className="mb-5 overflow-hidden border-round shadow-2">
                    <img 
                        alt={historia.titulo} 
                        src={baseImagenUrl + historia.urlImagen} 
                        onError={(e) => {
                            e.target.src = "/logos/logoua.png";
                            e.target.style.objectFit = "contain";
                            e.target.style.height = "auto"; 
                        }}
                        className="w-full"
                        style={{ maxHeight: '550px', objectFit: 'cover' }}
                    />
                </div>
                
                <div className="text-xl line-height-3 text-800 p-5 pt-0">
                    <p style={{ whiteSpace: 'pre-wrap' }}>
                        {historia.descripcion}
                    </p>
                </div>

                <hr className="my-5 surface-border" />

                <div className="flex justify-content-between align-items-center pb-5">
                    <Button 
                        label="Volver al listado" 
                        icon="pi pi-arrow-left" 
                        onClick={() => navigate('/listahistorias')} 
                        className="p-button-outlined p-button-secondary"
                    />
                    <Button 
                        label="Compartir" 
                        icon="pi pi-share-alt" 
                        className="p-button-text p-button-secondary"
                        onClick={() => navigator.clipboard.writeText(window.location.href)}
                    />
                </div>

            </div>
        </div>
    );
};

export default DetalleHistoria;